module.exports = __webpack_public_path__ + "img/1400_Keeper_logo.25d5f5f8.png";